// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__21zdp","selects":"Documents_selects__2iLmH"};